import Dozes from './Dozes'
export default Dozes
